import * as t from 'io-ts'

import fetchApi from "ui-io/fetch-api";

const taskRepublishMutation = ({ taskId }: { taskId: string }) => {
  return fetchApi({
    service: 'admin-service',
    method: 'POST',
    pathname: `/tasks/${taskId}/publish`,
    codec: t.unknown,
  })
}

export { taskRepublishMutation }
